<template>
  <b-overlay
    v-if="enableFeature"
    :show="showStatusPanel"
  >
    <b-card
      v-if="record"
      class="RealisationStatusPanel"
    >
      <h4>{{ statusLabel }}</h4>

      <div
        v-if="canConfirmTrafficDecisions && !completed"
        class="w-100"
      >
        <b-button
          v-if="!ConfirmedDate"
          :disabled="busy"
          :variant="action ? 'success' : 'outline-success'"
          class="w-100"
          @click="handleSetAction({ action: 'confirm' })"
        >
          {{ $tc('processes.sidebar.mark_vkb_as_irrevocable') }}
        </b-button>

        <b-button
          v-else
          :disabled="busy"
          :variant="action ? 'danger' : 'outline-danger'"
          class="w-100"
          @click="handleSetAction({ action: 'cancel' })"
        >
          {{ $tc('processes.sidebar.cancel_vkb_irrevocability') }}
        </b-button>
      </div>

      <p
        v-if="PublicationDate"
        class="mt-2"
      >
        {{ $t('processes.sidebar.vkb_published_on') }}: {{ PublicationDate }}<br>
        {{ $t('processes.sidebar.vkb_definitive_on') }}: {{ DefinitiveDate }}
      </p>

      <Feedback
        class="mt-2"
        :feedback="feedback"
      />

      <transition>
        <div v-if="action">
          <b-button
            :disabled="busy"
            variant="dark"
            class="w-100"
            @click="handleConfirm"
          >
            {{ $t('processes.sidebar.confirm') }}
          </b-button>
        </div>
      </transition>
    </b-card>

    <template #overlay>
      <div class="text-center">
        <!-- <span v-if="cancelled">
          Dit proces is niet actief.
        </span>
        <span v-else>
          Er is nog geen VKB gepubliceerd.
        </span> -->
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Process from '@/models/Process';
//import Location from '@/models/Location';

import Feedback from '@/components/form/Feedback.vue';

/**
 *
 */
export default {
  name: 'RealisationVKBStatus',
  components: {
    Feedback
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      busy: false,
      action: null,

      feedback: {
        show: false,
        message: ''
      }
    };
  },
  computed: {
    ...mapGetters('realisations', ['getSelectedRecord']),
    ...mapGetters('user', ['canConfirmTrafficDecisions']),
    ...mapGetters('processes', ['getSelectedProcess']),

    record() {
      return this.getSelectedRecord || this.getSelectedProcess
    },
    /**
     * @return {Location|null}
     */
    location() {
      return  this.record.getLocation();
    },

    completed() {
      try {
        return !!this.record.status.completed;
      } catch (e) {
        return false;
      }
    },

    cancelled() {
      try {
        return !!this.record.status.cancelled;
      } catch (e) {
        return false;
      }
    },
    TrafficDecisionDetails() {
      return this.location?.getTrafficDecisionDetails?.() || {};
    },
    /**
     *
     */
    PublicationDate() {
      return this.TrafficDecisionDetails.PublicationDate || false;
    },
    DefinitiveDate() {
      return this.TrafficDecisionDetails.DefinitiveDate || '-';
    },
    ConfirmedDate() {
      return this.TrafficDecisionDetails.ConfirmedDate || false;
    },

    /**
     * Title to summarize current status
     */
    statusLabel() {
      if (!this.PublicationDate) {
        return this.$t('processes.sidebar.vkb_not_yet_published');
      } else if (!this.ConfirmedDate) {
        return this.$t('processes.sidebar.vkb_not_yet_irrevocable');
      } else if (this.ConfirmedDate) {
        return this.$t('processes.sidebar.vkb_is_irrevocable');
      }

      return this.$t('processes.sidebar.vkb_status_unknown');
    },

    /**
     * Show an overlay with a message if the VKB is not yet published, or the process has been cancelled
     */
    showStatusPanel() {
      return !this.record || !this.PublicationDate || this.cancelled;
    },
    /**
     * Check whether any role in this tenant can actually access this feature
     */
    enableFeature() {
      return this.canConfirmTrafficDecisions;
    }
  },
  methods: {
    ...mapMutations('realisations', ['replaceRecord']),
    handleSetAction({ action }) {
      this.action = this.action === null ? action : null;
    },
    async handleConfirm() {
      try {
        this.busy = true;

        let payload = {
          ref: this.record.getRef(),
          action: this.action
        };

        const token = await this.$auth.getTokenSilently();
        const api = await fetch('/api/realisation_vkb_status', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });
        if (!api.ok) {
          // console.log(api)
          throw new Error('Unable to update the status');
        }
        const response = await api.json();
        const record = response.data.record
        const isRealisationProcess = record?.processType?.value === 'realisation'

        this.feedback = {
          show: true,
          variant: 'success',
          message:
            this.action === 'confirm'
              ? this.$i18n.t('processes.sidebar.markedAsIrrevocable')//'Het VKB is als onherroepelijk gemarkeerd'
              : this.$i18n.t('processes.sidebar.markedAsRevocable') //'Het VKB is niet langer onherroepelijk'
        };

        if (isRealisationProcess) {
          this.$store.dispatch('realisations/setSelectedRecord', { record })
        } else {
          const process = new Process({ data: record, ref: record._id });
          this.$store.dispatch('processes/setSelectedProcess', { process, copy: true })
          // Update process list //
          this.$store.dispatch('processes/replaceProcess', { process: response.data.record })
        }



        // reset panel state
        this.action = null;
        this.busy = false;
      } catch (e) {
        // console.log(e)
        this.busy = false;

        this.feedback = {
          show: true,
          variant: 'danger',
          message: 'De status wijziging is niet opgeslagen'
        };
      }
    }
  }
};
</script>

<style lang="scss"></style>
